import { useEffect, useState } from 'react';

function useFindElementHeight(ref) {
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    function updateHeight() {
      setContentHeight(ref?.current?.clientHeight);
    }
    window.addEventListener('resize', updateHeight);

    // when first on page, resize not trigger
    // so we can updateHeight to set initial height
    updateHeight();
    return () => window.removeEventListener('resize', updateHeight);
  }, [setContentHeight, ref]);

  return contentHeight;
}

export default useFindElementHeight;
